export function parseMMDDYYYY(mmddyyyy) {
    if (!mmddyyyy || typeof mmddyyyy !== "string") return null;
    const [mm, dd, yyyy] = mmddyyyy.split("/").map((x) => parseInt(x, 10));
    if (!mm || !dd || !yyyy) return null;
    const d = new Date(yyyy, (mm - 1), dd);
    // Validate round-trip (e.g., 02/30/2020 should be invalid)
    if (d.getFullYear() !== yyyy || d.getMonth() !== (mm - 1) || d.getDate() !== dd) return null;
    return d;
}

export function calcAgeYears(dobString) {
    const dob = parseMMDDYYYY(dobString);
    if (!dob) return NaN;
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const hasNotHadBirthdayThisYear =
        today.getMonth() < dob.getMonth() ||
        (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate());
    if (hasNotHadBirthdayThisYear) age -= 1;
    return age;
}

export function parseDOB(dob) {
    // Supports MM/DD/YYYY or ISO
    if (!dob) return null;
    const mdy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const m = String(dob).match(mdy);
    if (m) {
        const mm = Number(m[1]) - 1;
        const dd = Number(m[2]);
        const yy = Number(m[3]);
        const d = new Date(yy, mm, dd);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(dob);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function calculateAge(dob) {
    const d = parseDOB(dob);
    if (!d) return null;
    const now = new Date();
    let age = now.getFullYear() - d.getFullYear();
    const m = now.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
    return age;
}